import React, { useEffect, useState } from "react";
import CrearCargos from "../../../components/admin/cargos/cargos";
import ListadoCargos from "../../../components/admin/cargos/listadoCargos";

const initialState = {
  pre_cod_cargo: "",
  pre_cargo: "",
};

const Cargos = () => {
  const [updateList, setUpdateList] = useState(false);
  const [type, setType] = useState("save");
  const [state, setState] = useState(initialState);

  const updateListFn = () => {
    setUpdateList(!updateList);
  };

  const resetState = () => {
    setState(initialState);
  };

  return (
    <div className="h-100 px-3 bgfondo2 d-flex justify-content-start flex-column ">
      <CrearCargos
        updateListFn={updateListFn}
        state={state}
        setState={setState}
        type={type}
        setType={setType}
        resetState={resetState}
      />
      <ListadoCargos
        updateList={updateList}
        updateListFn={updateListFn}
        setState={setState}
        setType={setType}
      />
    </div>
  );
};

export default Cargos;
